import { AxiosResponse } from 'axios'
import { getRequest } from '../commonActions/get'
import { Requests } from '../../config/api'
import { postRequest } from '../commonActions/post'
import { BankDetailProps } from '../../declarations/finance'
import { putRequest } from '../commonActions/update'

export const GetFinance = async () => {
  console.log('query')
  try {
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getFinance
    })

    console.log('respon', response)
    const finance = response?.data?.finance
    const status = response?.status
    const success = response?.data?.success
    const message = response?.data?.message
    const errors = response?.data?.message
    const totalData = response?.data?.totalData

    return {
      status: status,
      finance,
      errors,
      message: message,
      success,
      totalData
    }
  } catch (error) {
    throw error
  }
}

export const ApplyFinanceSetting = async (payload: any) => {
  try {
    const response: AxiosResponse<any> = await postRequest({
      route: Requests.post.applyfinanceSetting,
      payload
    })
    const applyfinance = response?.data.finance
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return {
      applyfinance,
      status,
      message,
      errors
    }
  } catch (error) {
    console.error('Error in CreateInsuranceProvider:', error)
    throw error
  }
}

export const UpdateFinanceSetting = async (payload: any) => {
  try {
    const response: AxiosResponse<any> = await putRequest({
      route: Requests.update.applyFinance,
      payload: payload
    })
    console.log('dataresp', response)
    const bankingDetail = response?.data.finance
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return {
      bankingDetail,
      status,
      message,
      errors
    }
  } catch (error) {
    console.error('Error in CreateInsuranceProvider:', error)
    throw error
  }
}

export const CreateBankDetail = async (payload: BankDetailProps) => {
  try {
    const response: AxiosResponse<any> = await postRequest({
      route: Requests.post.bankDetail,
      payload
    })
    const bankingDetail = response?.data.bankingDetail
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return {
      bankingDetail,
      status,
      message,
      errors
    }
  } catch (error) {
    console.error('Error in CreateInsuranceProvider:', error)
    throw error
  }
}

export const GetBankDetail = async () => {
  try {
    const response: AxiosResponse<any> = await getRequest({
      route: Requests.get.getBankDetails
    })
    console.log('dataresp', response)
    const bankingDetail = response?.data.bankingDetail
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return {
      bankingDetail,
      status,
      message,
      errors
    }
  } catch (error) {
    console.error('Error in CreateInsuranceProvider:', error)
    throw error
  }
}

export const UpdateBankDetail = async (payload: BankDetailProps) => {
  try {
    const response: AxiosResponse<any> = await putRequest({
      route: Requests.update.bankingDetail,
      payload: payload
    })
    console.log('dataresp', response)
    const bankingDetail = response?.data.bankingDetail
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return {
      bankingDetail,
      status,
      message,
      errors
    }
  } catch (error) {
    console.error('Error in CreateInsuranceProvider:', error)
    throw error
  }
}

export const GetWallet = async () => {
  try {
    const response: AxiosResponse<any> = await getRequest({
      route: Requests.get.getWallet
    })
    const amount = response?.data.amount
    const status = response?.status
    const message = response?.data?.message
    const errors = response?.data?.errors

    return { amount, status, message, errors }
  } catch (error) {
    console.error('Error in wallet:', error)
    throw error
  }
}
